import { SlideOverFilters } from '@GxT-Team/gxt-components';
import { FilterOptions } from '@GxT-Team/gxt-components/dist/components/slideOverFilters/SlideOverFilters';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useMemo, useState } from 'react';
import { getProjectFilterOptions } from '../../../services/api/projectSettings';
import {
  GetProjectsParams,
  ProjectFilterOptions,
} from '../../../services/api/projectSettings/projectSettings.types';
import { ProjectSettingsFilterSlideOverType } from '../types';

type FilterOptionItem = { label: string; value: string };

const ProjectSettingsFilterSlideOver = ({
  show,
  closeModal,
  handleApplyFilters,
  filters,
}: ProjectSettingsFilterSlideOverType) => {
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const handleApply = () => {
    appliedFilters && handleApplyFilters(appliedFilters);
    closeModal();
  };

  const { data } = useQuery<AxiosResponse<ProjectFilterOptions>>({
    queryFn: getProjectFilterOptions,
    queryKey: ['project-filter-options'],
  });

  const filterOptions = useMemo(
    (): Record<'createdBy' | 'materialIds', FilterOptionItem[]> => ({
      createdBy: data?.data?.createdBy || [],
      materialIds: data?.data?.catalogItem || [],
    }),
    [data?.data],
  );

  const getFilterOptions = (key: keyof typeof filterOptions, header: string): FilterOptions => {
    return {
      header,
      isSearchAble: filterOptions[key].length >= 5,
      checkboxOptions: filterOptions[key]
        .sort((a: FilterOptionItem, b: FilterOptionItem) => a.label.localeCompare(b.label))
        .map((item: FilterOptionItem) => ({
          label: item.label,
          name: key,
          value: item.value,
          checked: appliedFilters?.[key]?.includes(item.value.toString()),
          onChange(filters: GetProjectsParams['filters']) {
            setAppliedFilters(filters);
          },
        })),
      onChangeCallback: () => undefined,
      isAccordionOpen: (appliedFilters?.[key] || []).length > 0,
    };
  };

  return (
    <SlideOverFilters
      isOpen={show}
      title="Project Filters"
      onCloseHandler={closeModal}
      onApplyHandler={handleApply}
      onResetHandler={() => {
        setAppliedFilters({});
      }}
      filtersOptions={[
        getFilterOptions('materialIds', 'Materials'),
        getFilterOptions('createdBy', 'Created By'),
      ]}
    />
  );
};

export default ProjectSettingsFilterSlideOver;
